export const countDown = {
  dayText: 'DIAS',
  hoursText: 'HORAS',
  title: 'COMEÇA EM:',
  minutesText: 'MINUTOS',
  now: 'AGORA'
};
